<template>
    <img src="/images/promo/hero-section/student.png"
     alt="Student" />
</template>

<script>
export default {};
</script>
